// extracted by mini-css-extract-plugin
export default {"container":"ZV-z","title":"_V-z","link":"aW-z"};